import { Link } from '@tanstack/react-router'

/** Links out to the existing config pages — the hub is a curated front door,
 *  it doesn't rewrite these working surfaces. */
const LINKS: ReadonlyArray<{ to: string; label: string; desc: string }> = [
  { to: '/hr/settings', label: 'Leave policy knobs', desc: 'Notice, escalation, capacity, reminders.' },
  { to: '/hr/holidays', label: 'Holidays', desc: 'Public-holiday calendar.' },
  { to: '/hr/slack', label: 'Slack', desc: 'Event routing + notification channels.' },
  { to: '/hr/calendar', label: 'Calendar', desc: 'Microsoft Graph shared-calendar sync — status + test.' },
  { to: '/hr/coverage', label: 'Coverage thresholds', desc: 'Team capacity limits.' },
]

export function AdminMoreConfigTab(): JSX.Element {
  return (
    <div style={{ display: 'grid', gap: 8, gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', maxWidth: 720 }}>
      {LINKS.map((l) => (
        <Link
          key={l.to}
          to={l.to}
          style={{
            display: 'block',
            padding: '12px 14px',
            border: '1px solid var(--border)',
            borderRadius: 10,
            background: 'var(--surface)',
            textDecoration: 'none',
          }}
        >
          <div style={{ fontWeight: 500, color: 'var(--primary)' }}>{l.label}</div>
          <div style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 2 }}>{l.desc}</div>
        </Link>
      ))}
    </div>
  )
}
